// extracted by mini-css-extract-plugin
export default {"pointer":"EditProfileView_pointer__fYUD9"};